<template>
  <footer class="v-d-declare">
    <div class="v-d-declare__content g-content">
      <div class="contact-info">
        <p class="contact-info__text">地址 | 104台北市中山區民生東路一段42號8F之12</p>
        <p class="contact-info__text portrait-show">電話 | (02)2511-1608</p>
        <p class="contact-info__text portrait-show">傳真 | (02)2511-8553</p>
      </div>

      <div class="declare">
        <p class="declare__rights">© 2021 All Rights Reserved by Premature Baby Foundation of Taiwan.</p>
        <p class="declare__policy-terms">
          <router-link :to="{name: 'privacy'}" class="privacy" aria-label="privacy policy">隱私權政策</router-link>
           | <router-link :to="{name: 'term-of-service'}" class="privacy" aria-label="term of service">服務條款</router-link>
           </p>
      </div>
    </div>
  </footer>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Footer',
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.v-d-declare {
  background-color: $c-declare-bg;
  width: 100%;
  @include padding(30px 23px);

  &__content {
    border-top: 1px solid $c-white;
  }

  &__content.g-content {
    padding: 0;
  }
}

.contact-info {
  margin-top: 24px;
  @include flex(center);

  &__text {
    @include font-style($c-white, 14, normal, 0.56px, 20px);
  }
}

.declare {
  margin-top: 20px;
  @include flex(center, center, column);

  &__rights {
    @include font-style($c-white, 14, normal, 1.4px, 20px);
    text-align: center;
  }

  &__policy-terms {
    margin-top: 20px;
    @include font-style($c-white, 14, normal, 1.4px, 20px);
  }
}

.portrait-show {
  display: none;
}

@media screen and (min-width: $tablet) {

  .contact-info {
    &__text {
      top: 110px;

      & + & {
        margin-left: 20px;
      }
    }
  }

  .declare {
    margin-top: 10px;

    &__rights {
    }

    &__policy-terms {
      margin-top: 10px;
    }
  }

  .portrait-show {
    display: inline-block;
  }
}
@media screen and (min-width: $pc) {
  .v-d-declare {
    @include flex(center);
    height: 60px;

    &__content {
      border-top: 0px;
      @include flex(space-between);
    }
  }

  .contact-info {
    margin-top: 0px;

    &__text {

    & + & {
      margin-left: 10px;
    }
    }
  }

  .declare {
    @include flex();
    margin-top: 0;

    &__rights {
      opacity: .5;
    }

    &__policy-terms {
      margin-top: 0px;
      margin-left: 14px;
      opacity: .5;
    }
  }
}

.privacy {
  @include font-style($c-white, 14, normal, 1.4px, 20px);
}
</style>
